import { type UseFormReturnType } from '@mantine/form';

export function isEmptyObject(obj: any): boolean {
  return Object.keys(obj).length === 0;
}

export const isEmptyForm = (form: UseFormReturnType<any>): boolean =>
  isEmptyObject(form.values);

export function omitProperty<T, K extends keyof T>(
  obj: T,
  prop: K
): Omit<T, K> {
  const { [prop]: _, ...rest } = obj;
  return rest;
}

export const isEmpty = (str: string | null | undefined): boolean => {
  return str === undefined || str === null || str === '';
};

export const downloadFileWithBearerToken = async (
    url: string,
) => {

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      console.error('Failed to download file, status:', response.status);
      return;
    }

    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = 'downloaded_file';

    if (contentDisposition && contentDisposition.includes('filename=')) {
      const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (fileNameMatch?.[1]) {
        fileName = fileNameMatch[1];
      }
    }

    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export interface JWTPayload {
  "serv": number[ ],
  "role": string,
  "jti": string,
  "sub": string,
  "iat": number,
  "exp": number
}

export const isJWTExpired = (token: string): boolean => {
  const payload: JWTPayload = JSON.parse(atob(token.split(".")[1]));
  const res = Math.floor(Date.now() / 1000) > payload.exp;

  return res;
}